/* eslint-disable new-cap */
import { useEffect, useRef, useMemo } from 'react';
import { Adriver, AdriverCustom } from '../../types';
import useScreenSize from '../useScreenSize';

interface useGalleryBannerProps {
  bannerId?: string;
  isBannerActivated?: boolean;
  isNextBanner?: boolean;
  setShouldRenderBanner?: React.Dispatch<React.SetStateAction<boolean>>;
  adriverCustom?: AdriverCustom;
}

export const useGalleryBanner = ({
  bannerId,
  isBannerActivated,
  isNextBanner,
  setShouldRenderBanner,
  adriverCustom
}: useGalleryBannerProps) => {
  const banner = useRef<null | Adriver>(null);
  const { isLarge } = useScreenSize();
  const custom = useMemo(
    () => adriverCustom || ({} as AdriverCustom),
    [adriverCustom]
  );
  const bannerData = useMemo(
    () => ({
      sid: 220686,
      bt: 52,
      bn: 22,
      w: 800,
      h: 600,
      custom
    }),
    [custom]
  );

  useEffect(() => {
    if (!isBannerActivated || !bannerId || !isLarge) return;

    try {
      banner.current = new window.adriver(bannerId, bannerData);
    } catch (e) {
      console.error(e);
    }
  }, [isBannerActivated, bannerId, isLarge, bannerData]);

  useEffect(() => {
    if (!isBannerActivated || !bannerId || !isLarge) return;
    const bannerElement = document.getElementById(bannerId);
    if (
      banner.current &&
      banner.current?.loadCompleteQueue?.flag &&
      bannerElement
    ) {
      bannerElement.innerHTML = '';

      banner.current?.reload();
    }
  }, [isBannerActivated, bannerId, isLarge, bannerData]);

  useEffect(() => {
    if (!isBannerActivated || !bannerId || !isLarge) return;
    const bannerElement = document.getElementById(bannerId);
    if (bannerElement) {
      bannerElement.innerHTML = '';
    }

    if (typeof window !== 'undefined' && typeof window.adriver === 'function') {
      window.adriver(bannerId, {
        ...bannerData
      });
    }
  }, [isBannerActivated, bannerId, isLarge, bannerData]);

  useEffect(() => {
    const innerHtml = banner.current?.p?.innerHTML;

    if (!innerHtml && isNextBanner && setShouldRenderBanner) {
      setShouldRenderBanner(false);
    }
  }, [banner.current?.p?.innerHTML, isNextBanner]);
};
